module.exports = __webpack_public_path__ + "static/media/calendar-edit.bcab96dc.svg";